import { Building06, Plus } from '@untitled-ui/icons-react/build/cjs';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ButtonCmp from 'src/components/ButtonCmp';
import PageSectionLayout from 'src/components/PageSectionLayout';
import Header from 'src/components/PageSectionLayout/Header/Header';
import type { RootState } from 'src/redux/store';

import OrganizationMembers from './OrganizationMembers';

const Organization = () => {
    //constants
    const { t } = useTranslation();
    const location = useLocation();
    const organizationMembersRef = useRef<any>(null);
    // WAL staff sessions cannot invite members (backend rejects it — the inviter has no divisions)
    const isWalUserSession = useSelector((state: RootState) => state.auth.currentUser?.isWalUserSession);

    const handleInviteClick = () => {
        organizationMembersRef.current?.handleInviteTeamMember();
    };

    // Auto-open invite modal when navigated from dashboard stepper
    useEffect(() => {
        if (location.state?.openInviteModal) {
            handleInviteClick();
        }
    }, []);

    return (
        <PageSectionLayout
            header={
                <Header
                    title={t('Organization.Organization')}
                    Icon={Building06}
                    isShowNotificationBox
                    leftClassName="!w-auto"
                    rightClassName="!w-auto"
                    rightSideContent={
                        <>
                            {!isWalUserSession && (
                                <ButtonCmp type="button" className="btn-outline-primary" onClick={handleInviteClick}>
                                    <div className="flex items-center gap-1">
                                        <Plus className="text-primary w-4 h-4" />
                                        {t('Organization.Invite_Team_Member')}
                                    </div>
                                </ButtonCmp>
                            )}
                        </>
                    }
                />
            }
        >
            <OrganizationMembers ref={organizationMembersRef} />
        </PageSectionLayout>
    );
};
export default Organization;
